/* Consent-aware ad-click attribution for accepted inquiries; no contact data. */
(() => {
  const KEY = "rr:inquiry:ad-click:v1";
  const TTL = 90 * 86400000;
  const PATTERN = /^[A-Za-z0-9_-]{8,512}$/;
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true &&
    window.Shopify?.customerPrivacy?.saleOfDataAllowed?.() === true;
  const clear = () => { try { window.localStorage.removeItem(KEY); } catch {} };
  const get = () => {
    if (!allowed()) { clear(); return null; }
    try {
      const value = JSON.parse(window.localStorage.getItem(KEY) || "null");
      const time = Date.parse(value?.capturedAt);
      if (!value || !Number.isFinite(time) || time > Date.now() || Date.now() - time > TTL ||
          value.adUserData !== true || value.adPersonalization !== true ||
          !["gclid", "wbraid", "gbraid"].some(key => PATTERN.test(value[key] || ""))) { clear(); return null; }
      const key = ["gclid", "wbraid", "gbraid"].find(name => PATTERN.test(value[name] || ""));
      return { [key]: value[key], capturedAt: value.capturedAt, adUserData: true, adPersonalization: true };
    } catch { clear(); return null; }
  };
  const capture = () => {
    if (!allowed()) { clear(); return; }
    const query = new URLSearchParams(location.search);
    const key = ["gclid", "wbraid", "gbraid"].find(name => PATTERN.test(query.get(name) || ""));
    if (!key) { get(); return; }
    const click = query.get(key);
    const previous = get();
    if (previous?.[key] === click) return; // Reloads never extend the retention clock.
    const value = { [key]: click, capturedAt: new Date().toISOString(), adUserData: true, adPersonalization: true };
    try { window.localStorage.setItem(KEY, JSON.stringify(value)); } catch {}
  };
  window.RrInquiryAttribution = Object.freeze({ get, allowed });
  document.addEventListener("visitorConsentCollected", capture);
  // Shopify may load its privacy API after this deferred script.
  let attempt = 0;
  const initialize = () => {
    if (window.Shopify?.customerPrivacy) { capture(); return; }
    if (++attempt < 20) window.setTimeout(initialize, 250);
  };
  initialize();
})();
